import type { Href } from "expo-router";
import { COLORS } from "../../lib/brand";
import { router } from "expo-router";
import { useEffect } from "react";
import { ActivityIndicator, View } from "react-native";

import { loadLoginProfile, roleToRoute } from "../../lib/auth";
import { useAuth } from "../../lib/authContext";

const FOREST = COLORS.FOREST.hex;

/**
 * Legacy /notifications URL — kept for back-compat with anything still
 * pointing at this path (old emails, deep links, dropdown footer in older
 * builds). Reads the user's role and redirects to the portal-scoped inbox
 * so the page renders inside the right shell.
 */
export default function NotificationsRedirect() {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      router.replace("/login?next=/notifications" as Href);
      return;
    }
    let cancelled = false;
    void (async () => {
      const profile = await loadLoginProfile();
      if (cancelled) return;
      if (!profile?.role) {
        router.replace("/student" as Href);
        return;
      }
      const portal = roleToRoute(profile.role);
      router.replace(`${portal}/notifications` as Href);
    })();
    return () => {
      cancelled = true;
    };
  }, [user, loading]);

  return (
    <View style={{ flex: 1, alignItems: "center", justifyContent: "center", backgroundColor: COLORS.SAND.hex }}>
      <ActivityIndicator size="large" color={FOREST} />
    </View>
  );
}
